export default [
  {
    id: 1,
    name: 'Las Luces de Palpanuma',
    shortDescription:
      'Nazca, una joven temerosa, abandona su isla y emprende un viaje peligroso hacia Palpanuma.',
    longDescription: `
     Nazca tiene catorce años y un mundo sin conocer. Ella es una chica muy
          temerosa y sensible que vive en una pequeña isla en el medio del mar
          llamada Noribo, la cual forma parte de un archipiélago en el Ártico
          conocido como Lyanangaia, una de las zonas más inhóspitas del planeta
          Tierra. Ella era muy solitaria, aunque no siempre fue así, sus padres
          eran sus únicos amigos, quienes además la protegían de todos los
          peligros que las islas escondían en sus sombras. Por ello, Nazca,
          nunca había tenido la necesidad de poner un pie afuera de su casa o
          hacer algo por su cuenta. Hasta que un día algo horrible pasa. Algo
          que la forzará a emprender un largo viaje a través de mar y tierra por
          todo el archipiélago en búsqueda de las luces de una misteriosa
          montaña llamada Palpanuma, sin saber que un latente peligro la estaría
          acechando desde el primer día que partió de su hogar.
    `,
    image: require('@/assets/Nazca_Portada.jpeg'),
    image2: require('@/assets/7.jpg'),
    details_button: 'Detalles',
  },
  // {
  //   id: 2,
  //   name: 'La guerra de los lobos',
  //   shortDescription:
  //     'En La guerra de los lobos, la traición y el honor se enfrentan en una epopeya militar donde familia y aliados se quiebran.',
  //   longDescription: `
  //     La Casa Ornstein de Stuttgart ha sido atacada en su propio territorio, traicionada por sus propios parientes refugiados en la República de Jutlandia. Sigfrida Ornstein, en coma, apenas logró sobrevivir al atentado gracias a la intervención de su hermano, Sigurd, quien quedó al borde de la muerte y con severas cicatrices. Ahora, el Imperio Germánico se moviliza y la Casa Ornstein marcha a la guerra con un solo objetivo: cobrar represalia por la traición de sus parientes y recuperar Jutlandia para gloria del Kaiser y Germania.
  //     La guerra de los lobos, segunda parte de la saga Imperium, nos sumerge en un conflicto donde las lealtades se quiebran, la familia se convierte en enemiga, y el honor se decide entre acero, sangre
  //     y fuego. Lorenzo Macchiavello construye una epopeya militar en la que el mayor peligro no está en el frente, sino en quienes deberían estar del mismo lado.
  //   `,
  //   image: require('@/assets/book_home_2.png'),
  //   image2: require('@/assets/homeimg2.png'),
  //   details_button: 'Detalles',
  // },
];
